import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { LongRunningContextCategoryTyp } from 'src/app/samwebDescription/samweb/waitingContext/waitingContextCategory';
import { LongRunningContextState } from 'src/app/store/server-communication/running-actions/long-running-context.state';

@Component({
   selector: 'samweb-grid-wait-for-data',
   templateUrl: './grid-wait-for-data.component.html',
   styleUrls: ['./grid-wait-for-data.component.scss'],
})
export class GridWaitForDataComponent implements OnInit {
   constructor(private store: Store) {}

   @Input()
   public brickInstanceIdFroLongRunningCheck: string;

   @Input()
   public disableInfinityScrollDuringLongRunningCategories: string[] = [];

   public isLoading$: Observable<boolean>;

   @Input()
   public wasSearchingEverStarted$: Observable<boolean> = of(true);

   @Input()
   public noRecords = false;

   ngOnInit() {
      this.isLoading$ = this.store.select(LongRunningContextState.isLongRunningContextInProgressForCategories).pipe(
         map((filterFn) =>
            filterFn(
               this.disableInfinityScrollDuringLongRunningCategories.map((x) => LongRunningContextCategoryTyp.valueByName(x)),
               this.brickInstanceIdFroLongRunningCheck
            )
         )
      );
   }
}
